import { render, staticRenderFns } from "./addressSearch.vue?vue&type=template&id=b2a94870&scoped=true&"
import script from "./addressSearch.vue?vue&type=script&lang=js&"
export * from "./addressSearch.vue?vue&type=script&lang=js&"
import style0 from "./addressSearch.vue?vue&type=style&index=0&id=b2a94870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a94870",
  null
  
)

export default component.exports